import React from "react";
import { stagesForBookingProduct } from "./unifiedFlightHotelStages";

export default function BookingStageNav({ product, activeId, onStage }) {
  const stages = stagesForBookingProduct(product, activeId);
  return (
    <nav className="hpm-stages" aria-label="שלבי הזמנה">
      {stages.map((stage, index) => (
        <button
          key={stage.id}
          type="button"
          className={`hpm-stage${stage.active ? " is-active" : ""}${
            stage.done ? " is-done" : ""
          }`}
          disabled={stage.active || !stage.done}
          onClick={() => {
            if (stage.done) onStage?.(stage.id);
          }}
        >
          <span className="hpm-stage__n">{index + 1}</span>
          {stage.label}
        </button>
      ))}
    </nav>
  );
}
